import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
  SkeletonList,
  SkeletonTextBlock,
} from '@/components/common/skeleton';

export const DesktopBulletinsScreenSkeleton: React.FC = () => (
  <SkeletonGroup>
    <View style={styles.centerColumn}>
      <SkeletonList count={4} gap={20}>
        <SkeletonCard>
          <SkeletonBone width={80} height={12} />
          <SkeletonBone width="85%" height={20} />
          <SkeletonTextBlock lines={3} lineHeight={14} lastLineWidth="60%" />
        </SkeletonCard>
      </SkeletonList>
    </View>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  centerColumn: {
    width: '100%',
    maxWidth: 840,
    alignSelf: 'center',
  },
});
